import { FC } from 'react';
import { IconPoints } from '@pro/common/IconPoints';

type IRewardPointsProps = {
    num: number;
};

export const RewardPoints: FC<IRewardPointsProps> = props => {
    const { num } = props;

    return (
        <div className={'g-points'}>
            <IconPoints size={86}/>
            <div className={'g-points-title'}>
                +{num}
            </div>
        </div>
    )
};
